import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { styles as simpleCalendarWeekStyles } from "@clockwise/web-commons/src/components/calendar/simple-calendar-week/SimpleCalendarWeek.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { alpha } from "@material-ui/core/styles";
export { hourText } from "@clockwise/web-commons/src/components/calendar/simple-calendar-week/SimpleCalendarWeek.styles";

export const workingHoursContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  zIndex: 15,
  position: "absolute",
  width: "100%",

  "&:hover": {
    "& .remove": {
      display: "block",
    },

    "& .body": {
      background: alpha(colors.yellow.standard, 0.3),
    },
  },

  "& .remove": {
    position: "absolute",
    opacity: 0.5,
    color: greys.white,
    backgroundColor: colors.yellow.standard,
    left: "50%",
    transform: "translateX(-50%)",
    width: 24,
    height: 24,
    padding: 0,
    marginTop: -40,
    cursor: "pointer",
    display: "none",

    "&:hover": {
      opacity: 1,
    },
  },

  "& .remove-shell": {
    position: "absolute",
    left: 0,
    right: 0,
    height: 24,
    marginTop: -24,
  },

  "& > .rounded-container": {
    display: "flex",
    flexDirection: "column",
    borderRadius: 8,
    flex: 1,
    overflow: "hidden",
  },

  "&.active": {
    zIndex: 16,
  },

  "& .drag-handle": {
    height: 12,
    cursor: "row-resize",
    background: colors.yellow.standard,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& .drag-indicator": {
      color: greys.white,
      width: 12,
      height: 12,
      transform: "rotate(90deg)",
    },
  },
  "& .body": {
    flex: 1,
    background: alpha(colors.yellow.standard, 0.1),

    "&.active": {
      background: alpha(colors.yellow.standard, 0.3),
    },
  },
};

export const slot: CSSProperties = {
  position: "absolute",
  zIndex: 16,
  width: "100%",

  "&:hover": {
    background: `repeating-linear-gradient(-45deg, ${colors.yellow.lightest}, ${colors.yellow.lightest} 5px, ${colors.yellow.standard} 5px, ${colors.yellow.standard} 10px)`,
    cursor: "pointer",
  },
};

export const fab: CSSProperties = {
  position: "fixed",
  bottom: 24,
  right: 24,
  zIndex: 20,
};

export const styles = {
  ...simpleCalendarWeekStyles,
  workingHoursContainer,
  slot,
  fab,
};
